module.exports = __webpack_public_path__ + "img/graphics-1.a232c302.svg";